import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function SelectTransactionPage() {
  const navigate = useNavigate();

  const handleSelect = (type) => {
    const clientDocId = localStorage.getItem("clientDocId");
    if (!clientDocId) {
      alert("Session expired. Please log in again.");
      navigate("/login");
      return;
    }

    navigate(
      type === "Purchase"
        ? `/en/questions?id=${clientDocId}`
        : `/en/refinance?id=${clientDocId}`
    );
  };

  return (
    <main
      style={{
        padding: "2rem",
        textAlign: "center",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
      }}
    >
      <div style={{ marginBottom: "2rem" }}>
        <h1 style={{ fontSize: "2rem", color: "#222" }}>
          Please select a transaction:
        </h1>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2rem",
            marginTop: "2rem",
          }}
        >
          <button
            onClick={() => handleSelect("Purchase")}
            style={{
              width: "140px",
              height: "140px",
              borderRadius: "50%",
              backgroundColor: "#0098BA",
              color: "white",
              fontSize: "1.1rem",
              fontWeight: "bold",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            }}
          >
            Purchase
          </button>
          <button
            onClick={() => handleSelect("Refinance")}
            style={{
              width: "140px",
              height: "140px",
              borderRadius: "50%",
              backgroundColor: "#019261",
              color: "white",
              fontSize: "1.1rem",
              fontWeight: "bold",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            }}
          >
            Refinance
          </button>
        </div>
      </div>
    </main>
  );
}
